import { useState } from "react";
import { Col, Row } from "reactstrap";
import { RoleMasterFilterType } from "../models/DashboardModels";
import { DEFAULT_OPTION } from "../utils/Constant";
import SearchBox from "../components/SearchBox";
import SelectBox from "../components/SelectBox";
import { useSelector } from "react-redux";
import { FormUtils } from "../utils/FormUtils";

interface ViewFilterProps {
  onApplyFilters: (viewFilter: RoleMasterFilterType) => void;
}

const RoleMasterFilters = ({
  onApplyFilters
}: ViewFilterProps) => {

  const [viewFilter, setViewFilter] = useState<RoleMasterFilterType>({
        roleName: "ALL",
        roleId: "ALL",
        roleStatus: DEFAULT_OPTION,
        lineOfBusiness: DEFAULT_OPTION,
    });

  const onResetFilter = () => {
    const resetFilter = {
        roleName: "ALL",
        roleId: "ALL",
        roleStatus: DEFAULT_OPTION,
        lineOfBusiness: DEFAULT_OPTION,
    };
    onApplyFilters(resetFilter);
    setViewFilter(resetFilter);
  };

  const {
    storeLOBData,
  } = useSelector((state: any) => state.grievances);

  const {
    roleStatusStore
  } = useSelector((state: any) => state.roleMaster);

  const roleStatusData = roleStatusStore ?? [];  
  
  const lobData = FormUtils.convertDataList(
      storeLOBData.data?? []
    );

  return (
    <div className="border rounded ps-3 pt-2 pe-3 pb-3 mb-3">
      <Row className="mb-2">
        <Col xs={8} md={3}>
          <SearchBox
            label="Role Name"
            placeHolder="Search by Role Name"
            maxLength={50}
            value={viewFilter.roleName !== 'ALL' ? viewFilter.roleName : ''}
            onChange={(e) => {
              setViewFilter({
                ...viewFilter,
                roleName: e.target.value,
              });
            }}
          />
        </Col>
        {/* <Col xs={8} md={3}>
          <SearchBox
            label="Role ID"
            placeHolder="Search by Role ID"
            value={viewFilter.roleId !== 'ALL' ? viewFilter.roleId : ''}
            onChange={(e) => {
              setViewFilter({
                ...viewFilter,
                roleId: e.target.value,
              });
            }}
          />
        </Col> */}
        <Col xs={8} md={3}> 
          <SelectBox
            label="Role Status"
            value={viewFilter.roleStatus}
            options={roleStatusData}
            onChange={(event: any) => {
              setViewFilter({
                ...viewFilter,
                roleStatus: event,
              });
            }}
          />
        </Col>
        <Col xs={8} md={3}> 
          <SelectBox
            label="Line of Business"
            value={viewFilter.lineOfBusiness}
            options={lobData}
            onChange={(event: any) => {
              setViewFilter({
                ...viewFilter,
                lineOfBusiness: event,
              });
            }}
          />
        </Col>
      </Row>

      <Row >
        <Col xs={6} md={3} className="d-flex align-items-center mb-2 buttons-container">
          <button
            className="button"
            onClick={() => {
              onApplyFilters(viewFilter);
            }}
          >
            {" "}
            Search{" "}
          </button>
          <button
            className="resetButton"
            onClick={() => {
              onResetFilter();
            }}
          >
            {" "}
            Reset{" "}
          </button>
        </Col>
      </Row>
    </div>
  );
};

export default RoleMasterFilters;